import React from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import { openModal } from '@kistler/skybase-ui/skybase-core/base/actions'
import { SbButton } from '@kistler/skybase-ui/skybase-components/sb-button'
import { EQUIPMENT_MODAL_ID } from '../constants.js'
import { messages as t } from '../equipment-i18n.js'

export const CreateEquipmentButton = () => {
  const { formatMessage: _ } = useIntl()
  const dispatch = useDispatch()

  return (
    <SbButton
      id="create-equipment-button"
      icon="sbi-plus"
      className="primary"
      onClick={() => dispatch(openModal(EQUIPMENT_MODAL_ID))}
    >
      {_(t.addNew)}
    </SbButton>
  )
}
